import React from 'react';
import { Tag } from '@navi/web-ui/lib/primitives';
import CircularLoaderIconCopy from '@cp/src/pages/Enach/Constants/CircularLoaderIconCopy';
import { CancelIcon } from '@navi/web-ui/lib/icons';
import { OrchestrationStatus } from './interfaces';

interface StatusTagProps {
  orchestrationStatus: OrchestrationStatus;
}

const StatusTag: React.FC<StatusTagProps> = ({ orchestrationStatus }) => {
  if (orchestrationStatus === OrchestrationStatus.IN_PROGRESS) {
    return (
      <div className="flex items-center gap-[6px]">
        <Tag
          color="yellow"
          variant="transparent"
          label="In Progress"
          startAdornment={<CircularLoaderIconCopy fill="var(--pending-fill-color)" />}
        />
      </div>
    );
  }

  if (orchestrationStatus === OrchestrationStatus.FAILURE) {
    return (
      <div className="flex items-center gap-[6px]">
        <Tag
          color="red"
          variant="transparent"
          label="Failed"
          startAdornment={<CancelIcon color="var(--red-base)" />}
        />
      </div>
    );
  }

  return null;
};

export default StatusTag;
